import React from 'react'
import Lottie from "lottie-react";
import intern from "./../lottie/intern.json";
import exp1 from "./../lottie/exp1.json";
const Experience = () => {
  return (
    
      <div className='flex flex-col h-auto  p-20 '>
    <div class="animate-pulse h-16 w-auto text-left font-bold tracking-widest text-transparent text-3xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 ">Experience/Internship </div>
    <div className=' flex md:flex-row lg:flex-row flex-col'>
    <div className=' w-full'>
    <div className="container mx-auto p-4">
      <div className="space-y-4">
        <div>
          <h3 className=" text-xl font-semibold font-mono mb-4 text-yellow-600 tracking-widest underline underline-offset-4">Full-Stack Developer Intern</h3>
          <p className="text-slate-400">May–Current 2023</p>
          <p className="italic text-slate-400 font-bold tracking-widest">At HomzNoffiz</p>
          <ul className="list-disc list-inside ml-4 text-slate-300">
            <li>Developed secure and user-friendly login and signup functionality for the site using MERN stack technologies.</li>
            <li>Implemented authentication and data validation to ensure seamless user registration and login experience.</li>
          </ul>
        </div>
        <div>
          <h3 className=" text-xl font-semibold font-mono mb-4 text-yellow-600 tracking-widest underline underline-offset-4">Frontend Developer Intern</h3>
          <p className="text-slate-400">June–August 2022</p>
          <p className="italic text-slate-400 font-bold tracking-widest">At Maven Foundation</p>
          <ul className="list-disc list-inside ml-4 text-slate-300">
            <li>Developed a streaming website niche to clone of Twitch TV using Tailwind CSS and React JS.</li>
            <li>Implemented secure and user-friendly login and signup functionality.</li>
          </ul>
        </div>
      </div>
      </div>
    </div>
    <div className=' w-full'><Lottie className='h-80' animationData={exp1}/><Lottie className='h-96' animationData={intern}/></div>
    </div>
    </div>
      
  )
}

export default Experience